/**
 * Indicate that we want to save registration main informations form values into store / local storage
 */
export const SAVE_REGISTRATION_MAIN_INFORMATIONS = "SAVE_REGISTRATION_MAIN_INFORMATIONS"

/**
 * Indicate that we want to clear registration main informations form values into store / local storage
 */
export const CLEAR_REGISTRATION_MAIN_INFORMATIONS = "CLEAR_REGISTRATION_MAIN_INFORMATIONS"
